// extracted by mini-css-extract-plugin
export default {"container":"main_container__FT6MR","primary":"main_primary__DlWNt","content":"main_content__vimMA","donatorsButton":"main_donatorsButton__lKRtn"};